if (typeof JW === 'undefined') JW = {};
JW.ClTree = function ($, tree)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'CLTREE';
    _pri.opts = {
        dbg_lvl:     1,
        iclosed_cls: 'fa-chevron-right',
        iopened_cls: 'fa-chevron-down',
        cnt_all_cls: 'cnt_all',
        msgs_cls:    'tree_msgs'
    };

    _pri.inited   = false;
    _pri.$tree    = null;
    _pri.$msgs    = null;
    _pri.$cnt_all = [];
    _pri.sects    = new Map();
    _pri.ids      = new Map();

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.init = function(tree)
    {
        if (_pri.inited)
        {
            _pri.dbgR('!!! already inited!?');
            return;
        }

        _pri.uid = JW.Page.getUId();

        _pri.dbgG('*** init() uid: ' + _pri.uid + ' ***');

        _pri.inited = true;
        _pri.page = JW.Page;
        _pri.$tree = $(tree);
        if (_pri.$tree.length == 0)
        {
            _pri.dbgR('!!! tree not found!?');
            return;
        }

        publ.cnt_all = 0;
        _pri.parseCnf();

        _pri.$tgls    = _pri.$tree.find('.exp');
        _pri.$cnt_all = _pri.$tree.find('.' + _pri.opts.cnt_all_cls).first();
        _pri.$msgs    = _pri.$tree.find('.' + _pri.opts.msgs_cls).first();

        _pri.$s_cljid = _pri.$tree.find('#cltree_cljid');
        _pri.$s_cljid.on('change', function(e) {

            let msg = '';
            let s_cljid = _pri.$s_cljid.val();
            _pri.dbg('*** s_cljid on change - val: ', s_cljid);

            if (s_cljid != '')
            {
                if (_pri.ids.has(s_cljid))
                {
                    _pri.dbg('    found ...');
                    let ido = _pri.ids.get(s_cljid);

                    if (_pri.sects.has(ido.prof0))
                    {
                        _pri.dbg('    found in sects ...');
                        let sect = _pri.sects.get(ido.prof0);
                        if (!sect.$exp.hasClass('opn'))
                        {
                            sect.$exp.trigger('click');
                        }

                        if (ido.$cb.is(':checked'))
                        {
                            msg = '<b>"' + ido.lbl + '"</b> ist bereits ausgewählt.';
                        }
                        else
                        {
                            ido.$cb.prop('checked', true).trigger('change');
                            window.setTimeout(function() {
                                JW.Modal.handleJSONRet({scrollto: '#' + ido.$cb.attr('id'), scrolltopoffs: 50});
                            }, 400);
                        }
                    }
                }

                _pri.dbg('    clear inp ...');
                // _pri.$s_cljid.val('');
                // _pri.$s_cljid.trigger('change');
                // _pri.$tree.find('#cltree_clj_inp').closest('.clri').trigger('click');
                // _pri.$s_cljid.val('').trigger('change');
                // _pri.$tree.find('#cltree_clj_inp').val('').trigger('change');
                // let $tin = _pri.$tree.find('#cltree_clj_inp');
                // $tin.val('').trigger('change');
                // _pri.page.trigger('page:clri_click', $tin);
                _pri.$s_cljid.val('');
                _pri.page.trigger('page:clri_click', _pri.$s_cljid);
            }
            // else
            // {
            //     _pri.$s_cljid.val('').trigger('change');
            // }

            _pri.$msgs.html(msg);
        });

        _pri.initTgl();

        _pri.$tree.data('inst', publ);
    };

    _pri.parseCnf = function()
    {
        let cnf = _pri.$tree.data('cnf');

        if (_pri.isObj(cnf) && $.isPlainObject(cnf))
        {
            $.each(cnf, function(k, v) {

                _pri.dbg('    cnf.k:', k, v);

                switch (k)
                {
                    case 'iclosed_cls':
                        _pri.opts.iclosed_cls = v;
                    break;

                    case 'iopened_cls':
                        _pri.opts.iopened_cls = v;
                    break;

                    case 'cnt_all_cls':
                        _pri.opts.cnt_all_cls = v;
                    break;

                    // case 'exm':
                    //     _pri.opts.exm = !!v;
                    // break;
                    //
                    // case 'exi':
                    //     _pri.opts.exi = !!v;
                    // break;
                    //
                    // case 'cis':
                    //     _pri.opts.cis = !!v;
                    // break;
                    //
                    // case 'nxtfoc':
                    //     _pri.opts.nxtfoc = !!v;
                    // break;
                    //
                    // case 'ppl':
                    //     if (v != '')
                    //     {
                    //         _pri.opts.ppl = v;
                    //     }
                    // break;
                    //
                    // case 'min':
                    //     if (v !== '')
                    //     {
                    //         _pri.opts.min = parseInt(v);
                    //     }
                    // break;
                    //
                    // case 'mxh':
                    //     if (typeof v !== 'undefined')
                    //     {
                    //         let mxh = parseInt(v);
                    //         if (mxh > 0)
                    //         {
                    //             _pri.opts.mxh = mxh;
                    //         }
                    //     }
                    // break;
                    //
                    // case 'idf':
                    //     if (typeof v !== 'undefined' && v != '')
                    //     {
                    //         _pri.idfInit(v);
                    //     }
                    // break;
                    //
                    // case 'idf2inp':
                    //     _pri.opts.idf2inp = !!v;
                    // break;
                    //
                    // case 'qps':
                    //     if (_pri.isObj(v) && $.isPlainObject(v))
                    //     {
                    //         $.each(v, function(k2, v2) {
                    //             _pri.opts.qps[k2] = v2;
                    //         });
                    //     }
                    // break;
                    //
                    // case 'cll':
                    //     if (_pri.isObj(v) && $.isPlainObject(v))
                    //     {
                    //         _pri.initCll(v);
                    //     }
                    // break;

                    default:

                    break;
                }

            });
        }
    };

    _pri.initTgl = function()
    {
        let $tgls    = _pri.$tree.find('.exp');
        $.each($tgls, function(k, v) {
            _pri.dbg('k:', k, 'v:', v);
            let $exp = $(v);
            $exp.on('click', function(e) {

                if ($exp.hasClass('opn'))
                {
                    $exp.removeClass('opn');
                    $exp.next().hide(400);
                }
                else
                {
                    $exp.addClass('opn');
                    $exp.next().show(400);
                }
                _pri.setState($exp);
            });

            let prof0 = $exp.data('prof0');
            let sect  =
            {
                $exp: $exp,
                $cnt: $exp.find('.cnt').first()
            };
            _pri.sects.set(prof0, sect);

            let $cbs = $exp.next().find('input[type="checkbox"]');
            $.each($cbs, function(k2, v2) {
                let $cb = $(v2);
                let lbl = $cb.parent().find('label').first().text();
                let ido =
                {
                    prof0: prof0,
                    $cb: $cb,
                    lbl: lbl
                };
                _pri.ids.set(ido.$cb.val(), ido);
            });

            $exp.next().find('>div>input[type="checkbox"]').change(function(e) {
                _pri.dbg('cb change');
                _pri.setState($exp);
                _pri.setCnts();
                // JW.Modal.handleJSONRet({keep_msgs: true}); // clear invalids
                _pri.$tree.removeClass('is-invalid').removeAttr('aria-invalid');
                _pri.$msgs.html(''); // clear tree_msgs
            });

            _pri.setState($exp);
        });

        _pri.setCnts();
    };

    _pri.setState = function($exp)
    {
        let $icon = $exp.find('i').first();

        if ($exp.hasClass('opn'))
        {
            $icon.removeClass(_pri.opts.iclosed_cls);
            $icon.addClass(_pri.opts.iopened_cls);
        }
        else
        {
            $icon.removeClass(_pri.opts.iopened_cls);
            $icon.addClass(_pri.opts.iclosed_cls);
        }
    };

    _pri.setCnts = () =>
    {
        let cnt_all = 0;

        _pri.sects.forEach(function(v, k) {

            $sel = v.$exp.next().find('input[type="checkbox"]:checked');
            _pri.dbg('    section checked.length:', $sel.length);
            if ($sel.length > 0)
            {
                v.$cnt.html($sel.length.toString());
                cnt_all += $sel.length;
            }
            else
            {
                v.$cnt.html('');
            }
        });

        // $.each(_pri.$tgls, function(k, v) {
        //
        //     let $exp = $(v);
        //     let $cnt = $exp.find('.cnt').first();
        //
        //     $sel = $exp.next().find('input[type="checkbox"]:checked');
        //     _pri.dbg($sel.length);
        //     if ($sel.length > 0)
        //     {
        //         $cnt.html($sel.length.toString());
        //         cnt_all += $sel.length;
        //     }
        //     else
        //     {
        //         $cnt.html('');
        //     }
        //
        // });

        if (_pri.$cnt_all.length > 0)
        {
            _pri.$cnt_all.html(cnt_all.toString());
        }

        publ.cnt_all = cnt_all;

        // _pri.page.trigger('cltree:set_cnts', {cnt: cnt_all});
    };

    // _pri.onClick = function(e)
    // {
    //     e.preventDefault();
    //     e.stopImmediatePropagation();
    //     e.stopPropagation();
    //
    //     _pri.dbg('*** onClick()');
    //
    //     _pri.$inp.prop('checked', !_pri.$inp.prop('checked')).trigger('change');
    //     _pri.page.trigger('btn_tgl:click', {name: _pri.$inp.attr('name'), state: _pri.$inp.prop('checked')});
    // };
    //
    // _pri.onInpChange = function(e)
    // {
    //     _pri.dbg('*** onChange()');
    //     _pri.setIcon();
    // };
    //
    // _pri.setIcon = function()
    // {
    //     if (_pri.$inp.prop('checked'))
    //     {
    //         _pri.$icon.removeClass('text-secondary fa-rotate-180');
    //         _pri.$icon.addClass('text-primary');
    //         _pri.$btn.prop('title', 'Abschalten: ' + _pri.opts.label);
    //         _pri.$btn.attr('aria-pressed', 'true');
    //     }
    //     else
    //     {
    //         _pri.$icon.removeClass('text-primary');
    //         _pri.$icon.addClass('text-secondary fa-rotate-180');
    //         _pri.$btn.prop('title', 'Einschalten: ' + _pri.opts.label);
    //         _pri.$btn.attr('aria-pressed', 'false');
    //     }
    // };

    // _pri.initOpts = function()
    // {
    //     _pri.opts.label     = _pri.$inp.data('label') || '';
    //     _pri.opts.label_cls = _pri.$inp.data('label_cls') || 'h5';
    // };

    _pri.extend();
    _pri.init(tree);

    return publ;
};
